import React, { useMemo } from 'react';
import CompanyInfoFormStore, {
  CompanyInfoFormContext,
} from 'store/pages/enrollment/company-info/companyInfoFormPageStore';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import PageContent from 'components/enrollment/company-info-form';

const CompanyInfoFormsPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new CompanyInfoFormStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <CompanyInfoFormContext.Provider value={pageStore}>
      <PageContent />
    </CompanyInfoFormContext.Provider>
  );
};

export default CompanyInfoFormsPage;
